import React from 'react'
import banner22 from '../assests/liv1.jpg';
import { alpha, Box, Button, Card, CardActions, CardContent, CardMedia, Container, FormControl, Grid, InputAdornment, InputBase, InputLabel, MenuItem, Paper, Slider, Stack, styled, TextField, Typography, useMediaQuery } from '@mui/material'
import { NumericFormat } from 'react-number-format';
import { HomeMaxOutlined } from '@mui/icons-material';
import BuyCal from '../components/Cards/BuyCal';


const CustomBanner = styled(Paper)(({ theme, Matches }) => ({
    background: ` linear-gradient(
        rgb(197 192 192 / 7%), 
        rgb(0 0 0 / 28%)
      ),url(${banner22})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'norepeat',
    backgroundPosition: 'center',
    overflow: 'hidden',
    // padding: 40,
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    alignItems: 'start',
    height: '100%',
    borderRadius: 0,
    marginTop: Matches ? '4em' : '3em'
}))

const StyledBtn1 = styled(Button)(({ theme, Matches }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    color: '#fff',
    background: '#978A7D',
    borderRadius: '80px',
    fontSize: '16px',
    padding: '7px 8px',
    fontWeight: 500,
    transition: '0.15s',
    textTransform: "none",
    width: '100%',
    maxWidth: Matches ? '180px' : '220px',
    minWidth: Matches ? '165px' : '190px',
    marginBottom: '0',
    marginRight: 'auto',
    '&:hover': {
        background: '#444444',
        color: '#fff',
    }
}))


const CommissionOffered = [
    {
        value: '1',
        label: '1%',
    },
    {
        value: '2',
        label: '2%',
    },
    {
        value: '3',
        label: '3%',
    },
    {
        value: '4',
        label: '4%',
    },
    {
        value: '5',
        label: '5%',
    },
]



const Buy = () => {
    const section1Ref = React.useRef(null);
    const section2Ref = React.useRef(null);
    const matches = useMediaQuery('(max-width:600px)');

    const scrollToSection1 = () => {
        section2Ref.current.scrollIntoView({ behavior: 'smooth' });
    };

    // Function to scroll to section 2
    const scrollToSection2 = () => {
        section1Ref.current.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <div>
            <Paper elevation={0} sx={{ mt: '3em' }} >
                <CustomBanner elevation={0} Matches={matches}>
                    <Box sx={{
                        m: matches ? '5em 2em' : '10em', display: 'flex', flexDirection: 'column', justifyContent: 'center',
                    }}>
                        <Stack spacing={1} display="flex" justifyContent="center" alignItems={matches ? 'start':"center"} sx={{
                            p: matches ? '2em 1em' : '3em 5em',
                            bgcolor: ' #ffffff9e',
                            // '#c3c4bfcf',
                            borderRadius: '10px',
                        }}>
                            <Typography variant='h5' gutterBottom sx={{fontSize: matches ? '16px' : null, textAlign:matches ? 'start': null,}}>
                                Buyers
                            </Typography>
                            <Typography variant="h4" gutterBottom textAlign="start" sx={{
                                fontSize: matches ? '22px' : null,
                                fontWeight: matches ? 600 : null,
                                letterSpacing: '-0.03em',
                            }}>
                                Experienced Brokers & Biggest Buyer Rebates
                            </Typography>
                            <Typography variant="h5" color="text.secondary" gutterBottom sx={{
                                textAlign: 'start', fontSize: matches ? '16px' : null,
                                fontWeight: matches ? 500 : null,
                                letterSpacing: '-0.03em',
                            }}>
                                Secure Your Dream Home and Enjoy Cash Benefits with Seamless Home Buying.
                            </Typography>
                        </Stack>
                        <Stack spacing={3} sx={{ p: '2em' }}
                            direction={matches ? "column" : "row"} display="flex" justifyContent="center" alignItems="center">
                            <StyledBtn1 color="primary" onClick={scrollToSection2} Matches={matches}>
                                Buying Process
                            </StyledBtn1>
                            <StyledBtn1 color="primary" onClick={scrollToSection1} Matches={matches}>
                                Calculate Cash Back
                            </StyledBtn1>
                        </Stack>
                    </Box>
                </CustomBanner>
                {/* <Card sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: 0, background: '#EFE8E5' }} elevation={0}>
                    <Box maxWidth="lg" sx={{ display: 'flex', flexDirection: 'column', width: '100%', justifyContent: 'start', alignItems: 'start', p: '0em 5em' }}>
                        <CardContent sx={{ display: 'flex', flexDirection: 'column',justifyContent: 'start', alignItems: 'start', }}>
                            <Typography variant='h5' gutterBottom>
                                Buyers
                            </Typography>
                            <Typography variant="h4" gutterBottom sx={{ textAlign: 'start', }}>
                                Experienced Brokers & Biggest Buyer Rebates
                            </Typography>
                            <Typography variant="h5" color="text.secondary" gutterBottom sx={{textAlign: 'start',}}>
                                Secure Your Dream Home and Enjoy Cash Benefits with Seamless Home Buying.
                            </Typography>
                        </CardContent>
                        <CardActions sx={{ display: 'flex', flexDirection: 'row',justifyContent: 'start', alignItems: 'start', }}>
                            <StyledBtn1 color="primary" onClick={scrollToSection2}>
                                Buying Process
                            </StyledBtn1>
                            <StyledBtn1 color="primary" onClick={scrollToSection1}>
                                Calculate Cash Back
                            </StyledBtn1>
                        </CardActions>
                    </Box>
                    <CardMedia
                        component="img"
                        sx={{ height: 700, width: '100%' }}
                        image={`${banner22}`}
                        title="green iguana"
                    />
                </Card> */}
            </Paper>
            <Paper elevation={0} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                <Container maxWidth="xl" sx={{ m: matches ? '2em 0em' : '3em 0em', }} >
                    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }} ref={section2Ref}>
                        <Stack spacing={0} display="flex" alignItems="center" >
                            <Typography variant="h6" gutterBottom sx={{fontSize: matches ? '16px' : null,
                                fontWeight: matches ? 500 : null,
                                letterSpacing: '-0.03em',}}>
                                Maximize Savings: Buyer's Get Huge Rebates & Results
                            </Typography>
                            <Typography variant="h4" gutterBottom sx={{ textAlign: 'start', mt: matches ? 0 : '10px',  fontSize: matches ? '22px' : null,
                                fontWeight: matches ? 600 : null,
                                letterSpacing: '-0.03em',}}>
                                Buyer's Rebate Calculator
                            </Typography>
                            <Typography variant="h7" color="text.secondary" component="div" gutterBottom 
                            sx={{fontSize: matches ? '16px' : null,
                                fontWeight: matches ? 500 : null,
                                letterSpacing: '-0.03em',}}>
                                Real Prop is only paid if you buy; Real Prop's Share is capped.
                            </Typography>
                        </Stack>
                    </Box>
                    <BuyCal section1Ref={section1Ref} />
                </Container>
            </Paper>
        </div>
    )
}

export default Buy